import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { NameSchema } from 'data/validation/CommonScemas';
import { useSnackbar } from 'notistack';
import { errorMessages, successMessages } from 'data/messages/messages';
import { useAddNewDocMutation } from 'redux/apiSlices/doc.slice';
import { TRtkErrorType } from 'data/types/general.types';
import Modal from 'components/Base/Modal';
import AddDocModalForm from './AddDocModalForm';

const AddDocModal: FC<{
  open: boolean;
  closeModal: () => void;
  projectId: string;
}> = ({ open, closeModal, projectId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [addNewDoc, { isLoading }] = useAddNewDocMutation();
  const { handleSubmit, formState, register } = useForm<{
    name: string;
  }>({
    defaultValues: {
      name: '',
    },
    resolver: yupResolver(NameSchema),
  });

  const onClose = () => {
    closeModal();
  };

  const onSubmit: SubmitHandler<{ name: string }> = async values => {
    try {
      await addNewDoc({ projectId, name: values.name }).unwrap();

      enqueueSnackbar(successMessages.toast, {
        variant: 'success',
      });
      closeModal();
    } catch (err) {
      const error = err as TRtkErrorType;
      enqueueSnackbar(error?.data?.message || errorMessages.default, {
        variant: 'error',
      });
    }
  };

  return (
    <Modal
      open={open}
      handleClose={onClose}
      title="New Docs & Files"
      submitButtonProps={{
        disabled: formState.isSubmitting,
        loading: isLoading,
        text: 'Create',
        onClick: handleSubmit(onSubmit),
      }}
      contentProps={{ sx: { minWidth: '300px' } }}
    >
      <AddDocModalForm
        onSubmit={handleSubmit(onSubmit)}
        formState={formState}
        register={register}
      />
    </Modal>
  );
};

export default AddDocModal;
